var map = {
	"./10-12-2020-v2/1024/img/Wing_feathers_Normal.png": "00a4",
	"./10-12-2020-v2/2048/img/Wing_feathers_Normal.png": "0ef0",
	"./10-12-2020-v2/512/img/Wing_feathers_Normal.png": "2fd8",
	"./10-12-2020-v3/1024/img/Wing_feathers_Normal.png": "0618",
	"./10-12-2020-v3/2048/img/Wing_feathers_Normal.png": "7e19",
	"./10-12-2020-v3/512/img/Wing_feathers_Normal.png": "a232"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e394";